import { render, staticRenderFns } from "./filipino-workforce.vue?vue&type=template&id=296a7d82&scoped=true&"
import script from "./filipino-workforce.vue?vue&type=script&lang=js&"
export * from "./filipino-workforce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a7d82",
  null
  
)

export default component.exports